module.exports = __webpack_public_path__ + "static/img/3.a53cac4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile@1x/bg/3.png
// module id = 8vpF
// module chunks = 0